import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import bindOwnClassnamesWithSkin from '../utils/bindOwnClassnamesWithSkin';
import SuccessIcon from '../Icons/Success';
import s from './InputLayout.scss';
var InputLayout = /** @class */ (function (_super) {
    tslib_1.__extends(InputLayout, _super);
    function InputLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.s = bindOwnClassnamesWithSkin(s, props.skin || {});
        return _this;
    }
    InputLayout.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { className: classnames(this.s('input-layout-paddings'), props.fullWidth && s['full-width'], props.className) },
            React.createElement("div", { className: this.s('input-layout-content', props.isFocused && 'focused', props.isFilled && 'filled', props.hasPlaceholder && 'has-placeholder', props.hasError && 'has-error', props.success && 'success', props.loading && 'loading', props.readOnly && 'read-only'), onClick: props.onClick },
                this.renderLabel(),
                React.createElement("div", { className: this.s('input-wrapper') },
                    props.children,
                    this.renderSuffix()),
                React.createElement("div", { className: this.s('bar') }),
                this.renderTextUnder())));
    };
    InputLayout.prototype.renderLabel = function () {
        var label = this.props.label;
        if (!label) {
            return null;
        }
        return (React.createElement("label", { htmlFor: this.props.id, className: this.s('label') }, label));
    };
    InputLayout.prototype.renderSuffix = function () {
        var _a = this.props, success = _a.success, suffix = _a.suffix;
        var suffixChildren = [];
        if (suffix) {
            suffixChildren.push(suffix);
        }
        if (success) {
            suffixChildren.push(React.createElement(SuccessIcon, null));
        }
        if (!suffixChildren.length) {
            return null;
        }
        return (React.createElement("div", { className: this.s('suffix') }, React.Children.toArray(suffixChildren)));
    };
    InputLayout.prototype.renderTextUnder = function () {
        var _a = this.props, hint = _a.hint, errorMessage = _a.errorMessage, showHintOnFocus = _a.showHintOnFocus, isFocused = _a.isFocused;
        var textUnder;
        if (hint && (!showHintOnFocus || isFocused)) {
            textUnder = React.createElement("span", { className: this.s('hint-under') }, hint);
        }
        if (errorMessage) {
            textUnder = React.createElement("span", { className: this.s('error-under') }, errorMessage);
        }
        if (!textUnder) {
            return null;
        }
        return (React.createElement("div", { onClick: this.onTextUnderClick, className: this.s('text-under') }, textUnder));
    };
    InputLayout.prototype.onTextUnderClick = function (e) {
        // clicking text under should not trigger onClick event -- it's not the control element
        e.stopPropagation();
    };
    return InputLayout;
}(React.Component));
export default InputLayout;
//# sourceMappingURL=InputLayout.js.map